// extracted by mini-css-extract-plugin
export default {"root":"IcBQDmuz7zN8dqBw25Dt"};